export enum Headers {
  APP = 'x-lwtears-app',
  APP_BUILD = 'x-lwtears-app-build',
  APP_VERSION = 'x-lwtears-app-version',
  APP_TARGET = 'x-lwtears-app-target',
  SESSION_ID = 'x-lwtears-session',
  LOCALE = 'x-lwtears-locale',
  USERNAME = 'x-ssousername',
  AUTH_TOKEN = 'x-authToken',
  METADATA = 'x-lwtears-metadata',
}
